import { useQuery } from "react-query";
import { fetchMarketSection } from "./fetchMarketSection";

const useTrendingLimit = () => {
  const { data, isLoading, isError } = useQuery("trendingLimit", async () => {
    const result = await fetchMarketSection(
      `${process.env.REACT_APP_SERVER_URL}/product/category/trending-deals`
    );
    return result || { trendingProducts: [] };
  });

  return { data, isLoading, isError };
};

export default useTrendingLimit;
